import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST_CHART_DEFINITION } from './equipment-timers-duration-by-product-list-chart.definition';
import { EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST_CHART_MOCK_DATA } from './equipment-timers-duration-by-product-list-chart.mock';

export const EquipmentTimersDurationByProductListChart = (props: ListChartProps) => <ListChart {...props} />;

EquipmentTimersDurationByProductListChart.definition = EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST_CHART_DEFINITION;
EquipmentTimersDurationByProductListChart.mockData = EQUIPMENT_TIMERS_DURATION_BY_PRODUCT_LIST_CHART_MOCK_DATA;
